import { Autocomplete, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

const FormAutocompleteArr = (props: {
  label: string;
  size?: 'small' | 'medium';
  options: any[];
  control: any;
  name: string;
  rules?: any;
  disableClearable?: boolean;
  freeSolo?: boolean;
  multiple?: boolean;
  fullWidth?: boolean;
}) => {
  const {
    size,
    options,
    rules,
    label,
    name,
    control,
    disableClearable,
    multiple,
    freeSolo,
    fullWidth,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <Autocomplete
            fullWidth={fullWidth}
            disableClearable={disableClearable}
            disablePortal
            options={options}
            onChange={(_, value) => onChange(value)}
            value={value}
            size={size}
            multiple={multiple}
            freeSolo={freeSolo}
            renderInput={(params) => <TextField error={!!error} {...params} label={label} />}
          />
          {error && (
            <Typography color="error" variant="body2">
              {error.message}
            </Typography>
          )}
        </>
      )}
    />
  );
};

export default FormAutocompleteArr;
